import React from 'react';
import { Icon } from './Icon.js';
export const IconLayoutMainContentFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M8,16H3.75c-1.517,0-2.75-1.233-2.75-2.75V4.75c0-1.517,1.233-2.75,2.75-2.75h4.25v1.5H3.75c-.689,0-1.25,.561-1.25,1.25V13.25c0,.689,.561,1.25,1.25,1.25h4.25v1.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "5.5", y: "2", width: "11.5", height: "14", rx: "2.75", ry: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconLayoutMainContentFill18.js.map